import * as React from 'react';
import Icon from '../Icon';

type NavButtonProps = {
  type?: 'back' | 'forward';
  onClick: () => void;
}

const NavButton = ({ type, onClick }: NavButtonProps) => (
  <button onClick={onClick} className="h-full px-3 cursor-pointer flex items-center">
    <Icon
      className="w-5 h-5"
      name={type === 'back' ? 'chevron-left' : 'chevron-right'}
    />
  </button>
);

export default NavButton;



// WEBPACK FOOTER //
// ./src/components/CourseCarousel/NavButton.tsx